import { ConverterExchangeProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-exchange-protocol.enum';
import { ConverterExchangeProtocolEnumI18n } from '@zaoblako/shared/modules/pacs/i18n/converter-exchange-protocol-enum.i18n';
import { ConverterReaderProtocolEnum } from '@zaoblako/shared/modules/pacs/enums/converter-reader-protocol.enum';
import { ConverterReaderProtocolEnumI18n } from '@zaoblako/shared/modules/pacs/i18n/converter-reader-protocol-enum.i18n';
import { ConverterInvertEventsDto, type ConverterInvertEventsInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-invert-events.dto';
import { ConverterPingSettingsDto, type ConverterPingSettingsInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-ping-settings.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { ConverterOperatingModeEnum } from '@zaoblako/shared/modules/pacs/enums/converter-operating-mode.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import type { NetPingDeviceFindInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-find.dto';

import * as yup from 'yup';

/** Converter create/update request body */
export interface ConverterFormInterface {
  /** Converter display name */
  name: string;
  /** Converter-FRM exchange protocol to use */
  exchangeProtocol: ConverterExchangeProtocolEnum;
  /** Converter card reader protocol */
  readerProtocol: ConverterReaderProtocolEnum;
  /** Converter events invertion settings */
  invertEvents?: ConverterInvertEventsInterface;
  /** Card ping settings */
  pingSettings?: ConverterPingSettingsInterface;
  /** Converter room */
  room?: RoomFindInterface;
  /** Converter operating mode */
  operatingMode?: ConverterOperatingModeEnum;
  /** "NetPing" device to observe lock status */
  netPingDevice?: NetPingDeviceFindInterface;
}

/** Converter create/update request body - DTO schema */
export const ConverterFormDto = SerdeDtoClass.create<ConverterFormInterface>(PacsDtoKeysEnum.CONVERTER_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  exchangeProtocol: {
    label: 'Протокол обмена',
    serializer: commonEnumValidator(ConverterExchangeProtocolEnum, ConverterExchangeProtocolEnumI18n),
  },
  readerProtocol: {
    label: 'Протокол считывателя карт',
    serializer: commonEnumValidator(ConverterReaderProtocolEnum, ConverterReaderProtocolEnumI18n),
  },
  invertEvents: {
    optional: true,
    label: 'Инверсия событий',
    nested: ConverterInvertEventsDto,
    serializer: (_, nested) => nested,
  },
  pingSettings: {
    optional: true,
    label: 'Настройки пинга',
    nested: ConverterPingSettingsDto,
    serializer: (_, nested) => nested,
  },
  room: {
    optional: true,
    label: 'Помещение',
    serializer: entityLikeSchema,
  },
  netPingDevice: {
    optional: true,
    label: 'Связанное устройство "NetPing"',
    serializer: entityLikeSchema,
  },
  operatingMode: {
    optional: true,
    label: 'Расписание режимов',
    serializer: yup
      .string()
      .oneOf(Object.values(ConverterOperatingModeEnum)),
  },
});
